export default __webpack_public_path__ + "static/media/drag.fb328c83.svg";